import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRadiation, faBiohazard } from '@fortawesome/free-solid-svg-icons';
import GLOBALS from '../config/globals';

const ICON_PRESETS = [
    { size: 180, duration: 7, delay: 0 },
    { size: 260, duration: 12, delay: 3.2 },
    { size: 48, duration: 9, delay: 1.1 },
    { size: 200, duration: 14, delay: 5.8 },
    { size: 140, duration: 8, delay: 2.4 },
    { size: 300, duration: 11, delay: 7.1 },
    { size: 80, duration: 6, delay: 0.6 },
    { size: 220, duration: 13, delay: 4.5 },
    { size: 160, duration: 10, delay: 6.3 },
    { size: 280, duration: 7, delay: 1.8 },
    { size: 36, duration: 15, delay: 3.9 },
    { size: 240, duration: 9, delay: 8.2 },
    { size: 120, duration: 12, delay: 5.1 },
    { size: 200, duration: 8, delay: 2.7 },
    { size: 160, duration: 11, delay: 9.4 },
];

const SPECIAL_GAME_ICONS = {
    [GLOBALS.SPECIAL_GAME_TYPES.RADIOACTIVE]: { icon: faRadiation, cssClass: 'radioactive-icon' },
    [GLOBALS.SPECIAL_GAME_TYPES.CORRUPTED]: { icon: faBiohazard, cssClass: 'corrupted-icon' },
};

const getIconCount = () => {
    if (typeof window === 'undefined') return 8;
    const width = window.innerWidth;
    if (width < 576) return 5;
    if (width < 1024) return 8;
    return 15;
};

const SpecialGameOverlay = ({ specialGameType }) => {
    const count = useMemo(getIconCount, []);

    const normalizedType = typeof specialGameType === 'string' ? specialGameType.toLowerCase() : '';
    if (!normalizedType) return null;

    const config = SPECIAL_GAME_ICONS[normalizedType];
    if (!config) return null;

    const maxSize = count <= 5 ? 100 : undefined;

    return (
        <div className="special-game-icons">
            {ICON_PRESETS.slice(0, count).map((preset, i) => {
                const fontSize = maxSize ? Math.min(preset.size, maxSize) : preset.size;
                const left = (i / count) * 100 + ((i * 37 + 11) % 7) - 3;
                return (
                    <span
                        key={i}
                        className={`special-game-icon ${config.cssClass}`}
                        style={{
                            left: `${left}%`,
                            fontSize: `${fontSize}px`,
                            animationDuration: `${preset.duration}s`,
                            animationDelay: `${preset.delay}s`,
                        }}
                    >
                        <FontAwesomeIcon icon={config.icon} />
                    </span>
                );
            })}
        </div>
    );
};

export default SpecialGameOverlay;
